import React, { useState } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

const RecursiveTreeView = ({ configTemplate, onChange, disabledRootEntities }) => {
  const renderTree = (node, nodeKey, previousLeafPath, showSections) => {
    const { name, exportValue, children, configSection, isPublic, isSelectable } = node;
    if (!isPublic) return null;
    const leafPath = previousLeafPath ? previousLeafPath + '.' + nodeKey : nodeKey;
    const treeLevel = leafPath.split('.').length;
    const marginLeft = treeLevel === 1 ? 15 : 25 * treeLevel;
    const style = treeLevel === 1 ? { borderBottom: 'inset' } : {};
    const treeToRender = configSection || children;
    const showNextSections = configSection && Object.keys(configSection).length > 1;
    const hideSection = nodeKey === 'Main' && !showSections;
    const disabledRootEntity = treeLevel === 1 && disabledRootEntities[nodeKey];
    return (
      <div key={nodeKey} style={style}>
        {!hideSection && (
          <FormControlLabel
            label={name}
            control={<Checkbox checked={exportValue} onChange={onChange(leafPath)} color="primary" />}
            disabled={!isSelectable || disabledRootEntity}
            style={{ marginLeft: marginLeft }}
          />
        )}
        {treeToRender &&
          Object.keys(treeToRender).map(
            childKey => exportValue && renderTree(treeToRender[childKey], childKey, leafPath, showNextSections)
          )}
      </div>
    );
  };

  return (
    <div style={styles.tree}>
      {Object.keys(configTemplate).map(initialNodeKey => renderTree(configTemplate[initialNodeKey], initialNodeKey))}
    </div>
  );
};

const styles = {
  tree: {
    border: 'groove',
    borderRadius: 10,
    height: 680,
    overflowY: 'auto',
  },
};

export default RecursiveTreeView;
